module.exports = __webpack_public_path__ + "assets/logo.0dbc2e9433acb7a36f8d6e7e92822bf0.png";